module.exports = __webpack_public_path__ + "img/schets-5.12ef6c09.jpg";